import { atom } from 'jotai'
import { TCustomer } from '../types/customer.type'

export const defaultCustomer: TCustomer = {
    humanName: {
        firstName: '',
        lastName: '',
        fullName: '',
        'fullName@en': ''
    },
    mainAddress: {
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: ''
    },
    unicity: 0,
    market: '',
    href: '',
    achievementsHistory: { href: '' },
    cumulativeMetricsProfile: { highestRankShort: '' },
    customerSite: { href: '' },
    draftBankAccounts: { href: '' },
    id: { unicity: '' },
    loginAssociations: { href: '' },
    metricsProfile: { href: '' },
    metricsProfileHistory: { href: '' },
    orders: { href: '' },
    profilePicture: { sizes: [], href: '' },
    sponsoredCustomers: { href: '' },
    statements: { href: '' },
    birthDate: '',
    coapplicant: {
        details: {
            humanName: {
                firstName: '',
                lastName: '',
                fullName: '',
                'fullName@en': ''
            }
        }
    },
    businessEntity: { legalType: '' },
    joinDate: '',
    status: '',
    type: '',
    email: '',
    rights: [],
    enroller: {
        href: '',
        id: { unicity: 0 },
        humanName: {
            fullName: '',
            firstName: '',
            lastName: '',
            'fullName@en': ''
        }
    },
    entryPeriod: '',
    faxNumber: '',
    homePhone: '',
    mobilePhone: '',
    referralCode: '',
    subscriptions: [],
    sponsor: {
        href: '',
        id: { unicity: 0 },
        humanName: {
            fullName: '',
            firstName: '',
            lastName: '',
            'fullName@en': ''
        }
    },
    taxTerms: { taxId: '' },
    workPhone: '',
    preferredName: {
        firstName: '',
        lastName: ''
    },
    timezone: '',
    warehousesHref: ''
}
export const customerState = atom<TCustomer>(defaultCustomer)
